import React from 'react';
import { View } from 'react-native';
import { PREFER_NOT_TO_ANSWER } from '../../../../helpers/familyProfile';
import useTranslation from '../../../../hooks/translation-hook';
import CustomButton from '../../../common/CustomButton';
import CustomCheckbox from '../../../common/CustomCheckbox';
import CustomTextInput from '../../../common/CustomTextInput';
import Label from '../../../common/Label';

type Props = { profileKey: string; value?: string; onChange(value: string): void };

const FamilyProfileFields = ({ profileKey, value, onChange }: Props) => {
  const t = useTranslation();
  const declined = value === PREFER_NOT_TO_ANSWER;
  const ages = !value || declined ? [''] : value.split(',');

  const updateAge = (index: number, age: string) => {
    onChange(ages.map((current, currentIndex) => currentIndex === index ? age : current).join(','));
  };

  const privacyChoice = <CustomCheckbox
      value={PREFER_NOT_TO_ANSWER}
      checked={declined}
      label={t('profile-prefer-not-to-answer')}
      labelNumberOfLines={3}
      onChange={checked => {
        if (checked !== declined) onChange(checked ? PREFER_NOT_TO_ANSWER : '');
      }}
    />;

  if (profileKey === 'HouseholdSize') {
    return <View>
      {!declined && <CustomTextInput
        accessibilityLabel={t('profile-family-situation')}
        keyboardType="number-pad"
        inputMode="numeric"
        digitsOnly
        maxLength={10}
        value={value ?? ''}
        onChangeText={onChange}
        containerStyle={{ marginTop: 12, marginBottom: 12 }}
      />}
      {privacyChoice}
    </View>;
  }

  return <View>
    {!declined && <View>
      {ages.map((age, index) => <View key={index} style={{ marginTop: 12 }}>
        <Label>{t('profile-child-age', { number: index + 1 })}</Label>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 12, marginTop: 6 }}>
          <CustomTextInput
            accessibilityLabel={t('profile-child-age', { number: index + 1 })}
            keyboardType="number-pad"
            inputMode="numeric"
            digitsOnly
            maxLength={2}
            value={age}
            onChangeText={next => updateAge(index, next)}
            containerStyle={{ flex: 1 }}
          />
          {ages.length > 1 && <CustomButton
            secondary
            title={t('profile-remove-child')}
            onPress={() => onChange(ages.filter((_, currentIndex) => currentIndex !== index).join(','))}
          />}
        </View>
      </View>)}
      <CustomButton secondary title={t('profile-add-child')} style={{ marginTop: 16 }} onPress={() => onChange([...ages, ''].join(','))} />
    </View>}
    <View style={{ marginTop: declined ? 0 : 12 }}>{privacyChoice}</View>
  </View>;
};

export default FamilyProfileFields;
